import React from "react";
import BaseIcon from "../../utils/BaseIcon";

var SearchSystemIcon = function SearchSystemIcon(props) {
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M5.995.828c4.973-2.113 10.718.205 12.832 5.178a9.784 9.784 0 01-1.575 10.197l6.495 6.495a.75.75 0 01-1.06 1.06l-6.495-6.495a9.78 9.78 0 01-2.543 1.575C8.676 20.952 2.931 18.634.817 13.66-1.296 8.687 1.022 2.942 5.995.828zm11.452 5.765a8.284 8.284 0 10-1.784 9.118l.017-.02a8.281 8.281 0 001.767-9.097z"
  })));
};

SearchSystemIcon.displayName = "SearchSystemIcon";
SearchSystemIcon.defaultProps = {
  size: 24
};
SearchSystemIcon.displayName = "SearchSystemIcon";
SearchSystemIcon.iconName = "Search";
export default SearchSystemIcon;